import React from "react";
import Slider from "react-slick";

function Formations(){

  const settings = {
    arrows: true,
    dots: true,
    mobileFirst: true,
    swipeToSlide: false,
    touchMove: true,
    cssEase: "ease-out",
  };
  
  return (
    

                <section id="formations">
                  <h2 className="fs-40">Formations</h2>
                  <Slider {...settings}>
                    <article >
                      <h3 className="mt-2em">Titre Professionnel Développeur Web et Web Mobile (DWWM) — RNCP niv. 5</h3>
                      <p className="text-blue">Obtenu en septembre 2023</p>
                      <p>Formation BeWeb | Organisme Fondespierre, Montpellier</p>
                    </article>
                    <article >
                      <h3 className="mt-2em">Management Hôtelier</h3>
                      <p className="text-blue">2015-2016</p>
                      <p>
                        Institut Supérieur de Gestion Hôtelière à l’Haute Ecole
                        Provinciale de Namur, Belgique
                      </p>
                    </article>
                    <article >
                      <h3>Licence d'Histoire</h3>
                      <p className="text-blue">2014-2015</p>
                      <p>Université Pierre Mendes France, Grenoble 38</p>
                    </article>
                    <article >
                      <h3 className="mt-2em">Baccalauréat STMG</h3>
                      <p className="text-blue">2011–2014</p>
                      <p>Lycée Le Corbusier, Poissy 78</p>
                    </article>
                    </Slider>

                </section>

    )
  }

  export default Formations
